

exports.__esModule = true;
exports.$xoPageAddCardMeftPageComponent = undefined;

var _uiRouter = require('uiRouter');

var _angular = require('angular');

var _squid = require('squid');

var _checkout = require('xo-models/src/checkout');

require('xo-validation/dist/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-wallet-components/src/add-card/directive');

require('xo-page-components/src/value-props/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddCardMeftPageComponent = exports.$xoPageAddCardMeftPageComponent = _squid.$Component.extend('$xoPageAddCardMeftPageComponent', {
    tag: 'xo-page-add-card-meft-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.locale = _squid.$locale;
        $scope.token = _angular.$rootScope.token;
        $scope.checkoutAppData = _checkout.$CheckoutAppDataModel.instance($scope.token);
        $scope.showmeftsection = {
            toggle: true
        };
        $scope.billingaddressupdated = {
            value: false
        };
        function populateInfoMessage() {
            var msg = _squid.$locale.content.get('DEMemberGuest.meftDeclinePageErrorMsg');

            $scope.message = {
                msgs: [msg],
                type: 'info'
            };
        }
        populateInfoMessage();

        $scope.useMeft = function () {
            return $scope.checkoutAppData.action('meft', {
                success: function success(result) {
                    // reload checkout session with new meft instrument.
                    _checkout.$CheckoutSessionModel.instance($scope.token).reload();
                    _uiRouter.$state.go('checkout.review');
                }
            });
        };

        $scope.callbacks = {
            finish: function finish() {
                return _uiRouter.$state.go('checkout.review');
            }
        };
    }]
});

angular.value("$xoPageAddCardMeftPageComponent", $xoPageAddCardMeftPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-card-meft/directive.js
// module id = ./pages/xo-add-card-meft/directive.js
// module chunks = 0